<template>
  <div>
    <br />
    {{ translate.result.stayAlert }}
    <br />
    {{ translate.result.slogan }}
  </div>
</template>

<script>
export default {
  name: 'result-footer',
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>
